import axios from "axios";

import delivery from "../delivery/delivery";

import {
    GET_DISTRIBUTOR_LIST,
    UPDATE_DISTRIBUTOR,
    UPDATE_DISTRIBUTORS,
    ADD_DISTRIBUTOR,
} from "./distributors.actionTypes";

import { BASE_URL } from "../../config";

const registerSessionListeners = (dispatch, updateDistributor) => {
    if (delivery.distributorListenersRegistered) {
        return;
    }
    let distributors = [];
    delivery.userUpdated((data) => {
        dispatch({
            type: UPDATE_DISTRIBUTORS,
            distributors: data.distributors,
        });
    });

    delivery.userJoined(() => {
        delivery.initUser();
    });
    delivery.initUser();

    delivery.distributorAdded((distributor) => {
        dispatch(updateDistributor(distributor));
    });

    delivery.distributorUpdated((distributor) => {
        distributors.push(distributor);
    });

    delivery.registerNotificationHandler((data) => {
        distributors.push(data);
    });

    setInterval(() => {
        if (distributors.length) {
            dispatch({
                type: UPDATE_DISTRIBUTORS,
                distributors,
            });
            distributors = [];
        }
    }, 10000);
    delivery.distributorListenersRegistered = true;
};

export const updateDistributor = (distributor) => {
    return {
        type: UPDATE_DISTRIBUTOR,
        distributor,
    };
};

export const addDistributor = (distributor) => {
    return {
        type: ADD_DISTRIBUTOR,
        distributor,
    };
};

export const getDistributorList = () => {
    return (dispatch) => {
        axios.get(`${BASE_URL}user/distributors`)
            .then((response) => {
                registerSessionListeners(dispatch, updateDistributor);
                const distributors = response.data;
                dispatch({
                    type: GET_DISTRIBUTOR_LIST,
                    distributors,
                });
            });
    };
};

export const getNewDistributorList = () => {
    return (dispatch) => {
        axios.get(`${BASE_URL}finance/balance/distributors`)
            .then((response) => {
                registerSessionListeners(dispatch, updateDistributor);
                const allDistributors = response.data;
                dispatch({
                    type: GET_DISTRIBUTOR_LIST,
                    allDistributors,
                });
            });
    };
};

export const getNearestDistributorList = (cb = {}) => {
    return (_) => {
        axios.get(`${BASE_URL}user/distributors/nearest`)
            .then((response) => {
                cb(response.data || []);
            });
    };
};
